import React from 'react';
import { ActivityIndicator } from './activity-indicator';
import { CachedImage } from '@usepepper/ui/atoms/cached-image';
import { LayoutSize, useLayoutContext } from '@/contexts/layout-context';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

const MIN_LOGO_WIDTH_PERCENTAGE = 0.75;
const SCREEN_SIZE_LOGO_HEIGHT_PERCENTAGE_GAP_MAP = {
  [LayoutSize.SMALL]: [0.2, 32],
  [LayoutSize.SMALL_TABLET]: [0.15, 32],
  [LayoutSize.MEDIUM]: [0.15, 48],
  [LayoutSize.LARGE]: [0.15, 60],
};

export const LogoLoadingIndicator: React.FC = () => {
  const theme = useTheme();
  const windowDimensions = useWindowDimensions();
  const { layoutSize } = useLayoutContext();

  const [heightPercentage, gap] =
    SCREEN_SIZE_LOGO_HEIGHT_PERCENTAGE_GAP_MAP[layoutSize];

  return (
    <View style={[styles.container, { gap }]}>
      <CachedImage
        alt="loading indicator"
        contentFit="contain"
        source={{ uri: theme.images.welcomeLogoUrl }}
        style={{
          height: windowDimensions.height * heightPercentage,
          minWidth: windowDimensions.width * MIN_LOGO_WIDTH_PERCENTAGE,
        }}
      />
      <ActivityIndicator size="large" testID="logo-activity-indicator" />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
});
